import { Pipe, PipeTransform } from '@angular/core';
import { isUndefined } from 'lodash';

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {
  transform(array: any, field: string, order?: string): any[] {
    order = isUndefined(order) ? "asc" : order;
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return  order == "asc" ?  -1 : 1;
      } else if (a[field] > b[field]) {
        return order == "asc" ? 1 : -1;
      } else {
        return 0;
      }
    });
    return array;
  }
}